import React from "react";
import { Container } from "../../03-base/Container";
import { LostAndFound } from "../00-blocks/LostAndFound";
import { Page } from "../01-sections/Page";
import * as I18n from "../../../../utils/translations/I18n";
export var NoMatchingRoute = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement(Page, null,
        React.createElement(Container, { theme: {
                padding: {
                    "": { y: 3 },
                    "sm": { y: 4 },
                },
            } },
            React.createElement(LostAndFound, { title: (_b = (_a = props.title) !== null && _a !== void 0 ? _a : I18n.getText("mary.09-views.02-pages.nomatchingroute.title", "Are you lost? (404) ")) !== null && _b !== void 0 ? _b : "", description: (_d = (_c = props.description) !== null && _c !== void 0 ? _c : I18n.getText("mary.09-views.02-pages.nomatchingroute.description", "Well, Claude certainly is.")) !== null && _d !== void 0 ? _d : "" }))));
};
